import React, { useState, useEffect } from 'react';
import '../styles/cookieBanner.css'

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const isAccepted = localStorage.getItem('cookieConsent');
        if (!isAccepted) {
            setIsVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    return (
        isVisible && (
            <div className="cookie-banner">
                <p className="cookie-text">
                    6698 sayılı KVKK ve GDPR uyarınca hazırlanmış aydınlatma metnimizi okumak ve sitemizle ilgili mevzutlara uygun olarak kullanılan çerezler için, Veri ve Çerez Politikasını ziyaret edebilirsiniz.
                </p>
                <button className="cookie-button" onClick={acceptCookies}>
                    Kabul Et
                </button>
            </div>
        )
    );
};

export default CookieBanner;
